/* import __COLOCATED_TEMPLATE__ from './profile-picture-upload.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';
import clsx from 'clsx';

/** @type {string} */
const CLASS_NAME = 'GLM-fields-profile-picture-upload';

/** @class */
class GlmFieldsProfilePictureUpload extends Component {
  @service('error-tracker') errorTracker;
  @service('commands/image-commands') imageCommandService;
  @service session;

  @tracked chosenPhoto = this.args.initialImageSrc;
  @tracked chosenPhotoUploadCompleteAnimate = false;
  @tracked caughtError = null;

  get classNames() {
    return clsx(
      CLASS_NAME,
      this.args.class,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get error() {
    return this.args.error ?? this.caughtError;
  }

  /**
   *
   */
  @task
  *uploadChange(e) {
    this.caughtError = null;
    this.chosenPhotoUploadCompleteAnimate = false;

    const [file] = e.target.files;

    if (file) {
      const reader = new FileReader();

      try {
        // read image
        const result = yield new Promise((resolve, reject) => {
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });

        this.chosenPhoto = result;

        // upload to cloudinary
        const imageData = yield this.imageCommandService.createDraftImage(file);
        this.args.onchange?.(imageData);

        // show fully complete
        this.chosenPhotoUploadCompleteAnimate = true;
      } catch (error) {
        this.errorTracker.error('Photo upload failed', this, error);
        this.caughtError = 'Image failed to upload';
      }
    }
  }
}

export default GlmFieldsProfilePictureUpload;
